import { FC, useCallback } from 'react';

import { getMemberFullName } from '../models/models-helpers';
import { styled } from '../theme';
import Text from './Text';
import TruncatedTextWithTooltip, {
    TruncatedTextWithTooltipContentProps,
} from './TruncatedTextWithTooltip';

const StyledText = styled(Text.withComponent('b'))(({ theme }) => ({
    fontSize: '1.5rem',
    fontWeight: theme.typography.fontWeight.heavy,
}));

type Props = {
    className?: string;
    account: {
        first_name: string;
        last_name: string;
    };
};

export const AccountName: FC<Props> = ({ account, className }) => {
    const fullName = getMemberFullName(account);

    const renderContent = useCallback(
        (props: TruncatedTextWithTooltipContentProps) => (
            <StyledText {...props} data-private data-testid="account-name">
                {fullName}
            </StyledText>
        ),
        [fullName]
    );

    return (
        <TruncatedTextWithTooltip
            text={fullName}
            className={className}
            renderContent={renderContent}
        />
    );
};

export default AccountName;
